<div mat-dialog-content>
    <p>Inserisci Password email EMMInformatica</p>
    <mat-form-field>
      <input type = "password" matInput [(ngModel)]="data.password">
    </mat-form-field>
  </div>
  <div mat-dialog-actions>
    <button mat-button (click)="onNoClick()">Annulla</button>
    <button mat-button [mat-dialog-close]="data.password" cdkFocusInitial>Ok</button>
  </div>